import React from 'react';
import Icon from './Icon';

const CheckMark = (props) => (
  <Icon width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="11" stroke="#00994D" strokeWidth="2"/>
    <path d="M9 11.9492L11.1213 14.0705L15.364 9.8279" stroke="#00994D" strokeWidth="2" strokeLinecap="round"/>
  </Icon>
);

export default CheckMark;
